import React from 'react';

import {
  LoadingAnimation,
  PageWrapper,
  TransparentModal,
} from '@order/components';

import { useNavigateBack } from '../../navigation';
import type { SweetpassPaymentMethodEditScreenProps } from '../../navigation/AppNavigation.props';
import { useSweetpassPaymentMethodEdit } from './hooks';
import { SweetpassPaymentMethodEditScreenContent } from './SweetpassPaymentMethodEditScreenContent';

export const SweetpassPaymentMethodEditScreen = (
  props: SweetpassPaymentMethodEditScreenProps,
) => {
  const { route } = props;
  const { paymentMethodId } = route.params;

  const navigateBack = useNavigateBack();

  const {
    hasActiveSubscription,
    paymentMethod,
    isSweetpassPaymentMethodLoading,
    isSettingActive,
    isRemoving,
    setActive,
    remove,
  } = useSweetpassPaymentMethodEdit({
    paymentMethodId,
  });

  return (
    <TransparentModal size="small" onClose={navigateBack}>
      <PageWrapper
        withoutFooter
        testID="sweetpass-membership.payment-method-edit.root.container"
      >
        {isSweetpassPaymentMethodLoading ? (
          <LoadingAnimation testID="sweetpass-membership.payment-method-edit.loading" />
        ) : (
          <SweetpassPaymentMethodEditScreenContent
            testID="sweetpass-membership.payment-method-edit"
            hasActiveSubscription={hasActiveSubscription}
            paymentMethod={paymentMethod}
            isSettingActive={isSettingActive}
            isRemoving={isRemoving}
            pressSetActiveHandler={setActive}
            pressRemoveHandler={remove}
          />
        )}
      </PageWrapper>
    </TransparentModal>
  );
};
